import {Fragment} from "react";
import {WordPressCalculatorResultLTL} from "./WordPressCalculatorResultLTL";

export const WordPressCalculatorResult = ({
                                              tab,
                                              lng,
                                              redirectToApp,
                                              palletDetail,
                                              calculatedResult
                                          }) => {

    return (
        <Fragment>
            {
                tab?.toLowerCase() === 'ltl' ?
                    <WordPressCalculatorResultLTL
                        lng={lng}
                        redirectToApp={redirectToApp}
                        palletDetail={palletDetail}
                        calculatedResult={calculatedResult}
                    />
                    :
                    <></>
            }
        </Fragment>
    )
}
